function e(r) {
  return wp.apiFetch({
    path: r.path,
    //'/rf/v4/data'
    method: "POST",
    data: r.data
  });
}
function h(r) {
  return e(r).then((t) => {
    if (t === null)
      throw new Error("Error with the REST API. Please contact the website admin and let them know this error.");
    if (t.error !== void 0)
      throw new Error(t.error);
    return t;
  });
}
export {
  e as apiFetch,
  h as apiFetchWithErrorCheck
};
